import React from 'react';
import SnappySearch from './SnappySearch';
import * as Styles from './NoSearchResult.styles';
import useLocale from '@/hooks/useLocale';

const NoSearchResult = () => {
  const { productDetails: productDetailsLocale } = useLocale();
  const { advancedHosting: advancedHostingLocale } = productDetailsLocale || {};

  return (
    <Styles.Container data-testid="advanced-hosting-no-search-result">
      <Styles.Content>
        <Styles.Header>
          <Styles.IconWrapper>
            <SnappySearch />
          </Styles.IconWrapper>
          <Styles.Text>
            <Styles.Title data-testid="advanced-hosting-no-search-result-title">{advancedHostingLocale?.noSearchResult?.title}</Styles.Title>
            <Styles.Subtitle data-testid="advanced-hosting-no-search-result-subtitle">{advancedHostingLocale?.noSearchResult?.subtitle}</Styles.Subtitle>
          </Styles.Text>
        </Styles.Header>
      </Styles.Content>
    </Styles.Container>
  );
};

export default NoSearchResult;
